import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { LEGAL } from "@/i18n/legal";
import Header from "@/components/landing/Header";
import ContactFooter from "@/components/landing/ContactFooter";
import Seo from "@/components/Seo";

const SITE = "https://tuningfiles.hu";

const LegalPage = ({ docKey }) => {
  const { t } = useLang();
  const doc = LEGAL[docKey];
  const path = docKey === "impressum" ? "/impressum" : "/datenschutz";

  return (
    <div className="relative min-h-screen bg-[#0A0A0A]" data-testid={`legal-page-${docKey}`}>
      <Seo
        title={`${doc.title} — TuningFiles.hu`}
        description={`${doc.title} von TuningFiles.hu (Betreiber DR-CODING).`}
        path={path}
      />
      <Header />

      <section className="px-5 pt-32 pb-20 md:px-10 md:pt-40 md:pb-28">
        <div className="mx-auto max-w-[820px]">
          <nav className="mb-8 flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-white/40" data-testid="breadcrumb">
            <Link to="/" className="transition-colors hover:text-brand-green">
              {t.footer.impressum === "Imprint" ? "Home" : "Főoldal"}
            </Link>
            <ChevronRight className="h-3 w-3" />
            <span className="text-white/70">{doc.title}</span>
          </nav>

          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="font-display text-5xl font-black text-white md:text-6xl"
          >
            {doc.title}
          </motion.h1>
          <p className="mt-4 font-mono text-xs uppercase tracking-widest text-white/40">
            {t.legalUi.updated}: {doc.updated}
          </p>

          <div className="mt-12 space-y-2">
            {doc.sections.map((s, i) => {
              if (s.type === "h")
                return (
                  <h2 key={i} className="pt-8 font-display text-xl font-bold text-white md:text-2xl">
                    {s.text}
                  </h2>
                );
              if (s.type === "ul")
                return (
                  <ul key={i} className="space-y-2 pt-2">
                    {s.items.map((it) => (
                      <li key={it} className="flex items-start gap-3 text-white/70">
                        <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 bg-brand-green" />
                        <span className="leading-relaxed">{it}</span>
                      </li>
                    ))}
                  </ul>
                );
              return (
                <p key={i} className="whitespace-pre-line pt-2 leading-relaxed text-white/70">
                  {s.text}
                </p>
              );
            })}
          </div>
        </div>
      </section>

      <ContactFooter />
    </div>
  );
};

export default LegalPage;
